import { Box } from '@mui/material';
import { FC } from 'react';
import { VideoPlayer } from '../../../../lib/components/compound/video';

export const OnboardingIntro: FC = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      height="100%"
    >
      <VideoPlayer url="https://files.pxtra.de/app-videos/thisispxtra_FINAL.mp4" />
    </Box>
  );
};
